<template>
    <div :class="containerClass"
         @click="onClick($event)"
         @mouseleave="$refs.input.blur()">
        <div class="p-hidden-accessible">
            <input ref="input"
                   :aria-label="ariaLabel"
                   :checked="checked"
                   :value="value"
                   type="checkbox"
                   v-bind="$attrs"
                   @blur="onBlur($event)"
                   @focus="onFocus($event)"
                   @keydown.enter="onClick($event)">
        </div>
        <div ref="box"
             :aria-checked="checked"
             :class="['p-checkbox-box elevation-2', {'p-highlight': checked, 'p-disabled': $attrs.disabled, 'p-focus': focused}]"
             role="checkbox">
            <span :class="['p-checkbox-icon far fa-check', {'p-checkbox-icon-visible': checked}]"></span>
        </div>
    </div>
</template>

<script>
import ObjectUtils from 'primevue/utils/ObjectUtils'

export default {
    inheritAttrs: false,
    props: {
        value: null,
        modelValue: null,
        binary: Boolean,
        trueValue: {
            type: null,
            default: true
        },
        falseValue: {
            type: null,
            default: false
        },
        ariaLabel: {
            type: String,
            default: Lang.langGet('Select')
        },
    },
    model: {
        prop: 'modelValue',
        event: 'input'
    },
    data() {
        return {
            focused: false
        }
    },
    methods: {
        onClick(event) {
            if (!this.$attrs.disabled) {
                let newModelValue

                if (this.binary) {
                    newModelValue = this.checked ? this.falseValue : this.trueValue
                } else {
                    if (this.checked)
                        newModelValue = this.modelValue.filter(val => !ObjectUtils.equals(val, this.value))
                    else
                        newModelValue = this.modelValue ? [...this.modelValue, this.value] : [this.value]
                }

                this.$emit('click', event)
                this.$emit('input', newModelValue)
                this.$emit('change', event)
                this.$refs.input.focus()
            }
        },
        onFocus(event) {
            this.focused = true
            this.$emit('focus', event)
        },
        onBlur(event) {
            this.focused = false
            this.$emit('blur', event)
        }
    },
    computed: {
        checked() {
            return this.binary ? this.modelValue === this.trueValue : ObjectUtils.contains(this.value, this.modelValue)
        },
        containerClass() {
            return ['p-checkbox p-component', {
                'p-checkbox-checked': this.checked,
                'p-checkbox-disabled': this.$attrs.disabled,
                'p-checkbox-focused': this.focused
            }]
        }
    }
}
</script>
